export const ESSENTIAL_TOOLS_IDS = {
  EMAIL: 1,
  LINK_IN_BIO: 2,
  GATOR_PROTECT: 3,
  DOMAIN: 4,
  SITE_BUILDER: 5,
  SITE_LOCK: 6,
};
